module.exports = __webpack_public_path__ + "static/media/about_01.5b2ce6c3.png";